module.exports = __webpack_public_path__ + "static/media/Illus-Thanks@2x.ff05c86d.png";